import { render, staticRenderFns } from "./BaseInfoMsg.vue?vue&type=template&id=8e78c5d6&"
import script from "./BaseInfoMsg.vue?vue&type=script&lang=js&"
export * from "./BaseInfoMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e78c5d6')) {
      api.createRecord('8e78c5d6', component.options)
    } else {
      api.reload('8e78c5d6', component.options)
    }
    module.hot.accept("./BaseInfoMsg.vue?vue&type=template&id=8e78c5d6&", function () {
      api.rerender('8e78c5d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/BaseInfoMsg.vue"
export default component.exports